import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { set } from '@ember/object';
import { dasherize } from '@ember/string';

export default class GoalCreateRoute extends Route {
  @service navbarSettings;
  @service router;
  @service settings;

  model() {
    set(this, 'navbarSettings.title', 'Select Goal Type');
    return {
      availableGoalTypes: this.settings.fundSettings.availableGoalTypes,
    };
  }

  redirect(model) {
    if (model.availableGoalTypes.length === 1) {
      this.router.replaceWith(
        `funds.fund.goal.${dasherize(model.availableGoalTypes[0])}`,
      );
    }
  }
}
